// extracted by mini-css-extract-plugin
export var textInput = "_g0-0";